import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import OAuthFooter from './OAuthFooter';
import OAuthHeader from './OAuthHeader';
import { setTokens } from '../utils/authFetch';

const endpoint = (token) => `/api/accounts/activate/${token}/`;

export default function ActivationPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('checking');
  const [message, setMessage] = useState('Проверяем ссылку приглашения…');
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const finish = (data) => {
    if (data.access && data.refresh) setTokens({ access: data.access, refresh: data.refresh });
    setMessage(data.detail || 'Аккаунт активирован.');
    setState('success');
  };

  useEffect(() => {
    let active = true;
    const check = async () => {
      try {
        const response = await fetch(endpoint(token), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' });
        const data = await response.json().catch(() => ({}));
        if (!active) return;
        if (!response.ok) {
          setMessage(data.detail || 'Ссылка недействительна или уже истекла.');
          setState('error');
        } else if (data.requires_password) {
          setMessage('Задайте пароль для нового аккаунта.');
          setState('password');
        } else {
          finish(data);
        }
      } catch {
        if (active) { setMessage('Не удалось связаться с OAuth-сервисом.'); setState('error'); }
      }
    };
    if (token) check();
    else { setMessage('В ссылке отсутствует токен активации.'); setState('error'); }
    return () => { active = false; };
  }, [token]);

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 10) return setMessage('Пароль должен содержать не менее 10 символов.');
    if (password !== repeatPassword) return setMessage('Пароли не совпадают.');
    setBusy(true);
    try {
      const response = await fetch(endpoint(token), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password }) });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) { setMessage(data.detail || 'Не удалось активировать аккаунт.'); return; }
      finish(data);
    } catch {
      setMessage('Не удалось связаться с OAuth-сервисом.');
    } finally { setBusy(false); }
  };

  return <div className="min-h-screen bg-black text-white"><OAuthHeader />
    <main className="mx-auto flex min-h-[calc(100vh-180px)] max-w-lg items-center px-4 py-20">
      <section className="w-full rounded-2xl border border-white/10 bg-slate-900/70 p-7 shadow-2xl backdrop-blur">
        <div className="mb-6 text-center"><div className="mx-auto mb-4 grid h-16 w-16 place-items-center rounded-full bg-gradient-to-br from-violet-600 to-cyan-500 text-xl font-bold">8%</div><h1 className="text-2xl font-bold">Активация аккаунта</h1><p className={`mt-3 text-sm ${state === 'error' ? 'text-red-300' : 'text-slate-300'}`}>{message}</p></div>
        {state === 'checking' && <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-violet-300/30 border-t-violet-300" />}
        {state === 'password' && <form onSubmit={submit} className="space-y-4"><label className="block text-sm text-slate-300">Новый пароль<input value={password} onChange={(event) => setPassword(event.target.value)} type="password" minLength="10" autoComplete="new-password" required className="mt-2 w-full rounded-lg border border-white/10 bg-slate-950 px-3 py-3 text-white outline-none focus:border-violet-400" /></label><label className="block text-sm text-slate-300">Повторите пароль<input value={repeatPassword} onChange={(event) => setRepeatPassword(event.target.value)} type="password" minLength="10" autoComplete="new-password" required className="mt-2 w-full rounded-lg border border-white/10 bg-slate-950 px-3 py-3 text-white outline-none focus:border-violet-400" /></label><p className="text-xs text-slate-500">Минимум 10 символов. Администратор не увидит этот пароль.</p><button disabled={busy} className="w-full rounded-lg bg-gradient-to-r from-violet-600 to-indigo-600 py-3 font-semibold disabled:opacity-60">{busy ? 'Активируем…' : 'Создать пароль и активировать'}</button></form>}
        {state === 'success' && <div className="space-y-3"><div className="rounded-lg border border-emerald-400/20 bg-emerald-400/10 p-3 text-sm text-emerald-200">Email подтверждён, учётная запись готова к работе.</div><button onClick={() => navigate('/')} className="w-full rounded-lg bg-gradient-to-r from-violet-600 to-indigo-600 py-3 font-semibold">Продолжить</button><a href="https://eight-percent.com" className="block text-center text-sm text-violet-300 hover:text-violet-200">На главный сайт</a></div>}
        {state === 'error' && <div className="space-y-3"><Link to="/" className="block w-full rounded-lg bg-gradient-to-r from-violet-600 to-indigo-600 py-3 text-center font-semibold">Открыть OAuth</Link><p className="text-center text-xs text-slate-500">Нужна помощь? admin@eight-percent.com</p></div>}
      </section>
    </main><OAuthFooter />
  </div>;
}
